import { render } from "./Reminder.vue?vue&type=template&id=32953cdb&scoped=true"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"

import "./Reminder.vue?vue&type=style&index=0&id=32953cdb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32953cdb"]])

export default __exports__